module.exports = __webpack_public_path__ + "static/img/46.912cdbb5.png";